<template>
  <div id="app">
    <!-- TOPBAR -->
    <top-bar v-if="credentials.logged && !credentials.cambiarPass && configuracionCargada"/>
    
    <!-- SIDEBAR -->
    <div class="d-flex wrapper">
      <side-bar v-if="credentials.logged && !credentials.cambiarPass && configuracionCargada"/>
      <div v-if="credentials.cambiarPass || !credentials.logged || (credentials.logged && configuracionCargada)"
        class="container-fluid content" :style="{ height: contentHeight + 'px'}">
        <div class="text-center border-bottom d-block d-xl-none font-weight-bold" style="margin-top: -14px;">{{ telefonoCorreduria}}</div>
        <router-view />
      </div>
      <div v-else class="text-center w-100 text-primary-dark pt-5">
        <font-awesome-icon icon="spinner" class="fa-spin"/> Cargando configuración
      </div>
    </div>
  </div>
</template>

<script>
// Componentes
import TopBar from '@/components/comunes/TopBar'
import SideBar from '@/components/comunes/SideBar'
import { mapGetters } from 'vuex';
export default {
  name: 'app',
  data() {
    return {
      contentHeight: 500
    }
  },
  mounted() {
    if (this.credentials.logged) {
      this.$store.dispatch("loadParametros")
      this.getAvisos()
      // Busca avisos nuevos cada X tiempo definido en la configuracion
      setInterval(() => {
        this.getAvisos()
      }, this.tiempoRecargaAvisos)
    }
    this.calcContentHeight()
    window.addEventListener("resize", this.calcContentHeight)
  },
  computed: {
    ...mapGetters({
      credentials: 'credentials',
      configuracionCargada: 'configuracionCargada',
      estados: 'estados',
      tiempoRecargaAvisos: 'tiempoRecargaAvisos',
      telefonoCorreduria: 'telefonoCorreduria'
    })
  },
  methods: {
    calcContentHeight() {
      this.contentHeight = window.innerHeight - 53;
    },
    getAvisos() {
      console.log("Get avisos")
      let payload = {
        params: {
          'sort': 'incidenciaCliente.fechaCreacion',
          'usuarioWebCliente': 'false',
          'inverse': true,
          'page': 1,
          'limit': 300
        },
        callbackOk: (responses) => {
          this.loading = false
        }
      }
      this.$store.dispatch("loadAvisos", payload)
    }
  },
  components: {
    TopBar,
    SideBar
  }
}
</script>

<style lang="sass">
  // Variables propias de bootstrapious
  @import './styles/variables.scss';

  //Bootstrap
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>

<style>
h2.seccion {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 10px;
  text-transform: uppercase;
  font-size: 1.5rem;
}
th {
  border-top: 0!important;
}
.content {
  padding-top: 15px;
  overflow: auto;
}
.logo-cia-gr {
  width: 175px;
  height: 88.89px;
}
.label-ficha {
  font-weight: bold;
  text-transform: uppercase;
  display: block;
  margin-bottom: 2px;
  margin-top: 10px;
  border-bottom: 1px solid #dee2e6;
  font-size: 0.8rem;
}
.label-form {
  font-weight: bold;
  text-transform: uppercase;
  display: block;
  margin-bottom: 2px;
  margin-top: 10px;
  font-size: 0.8rem;
}
.nav-tabs {
  border: 0!important;
}
.nav-link {
  border-left: 0!important;
  border-right: 0!important;
  border-top: 0!important;
  border-width: 3px!important;
}
.nav-item {
  margin-right: 6px!important;
}
img.avatar {
  width: 50px;
  height: 50px;
  border-radius: 25px!important;
  border-width: 3px!important;
}
th.sortable {
  background-image: url('/sortable.png');
  background-position: left center;
  background-repeat: no-repeat;
  cursor: pointer;
  padding-left: 14px;
}
th.sort {
  background-image: url('/sort-ascend.png');
}
th.sort.reverse {
  background-image: url('/sort-reverse.png');
}
.stepper {
  padding-left: 15px!important;
  padding-right: 15px!important;
}
.stepper-stage {
  background: transparent url('/dot.png') center 40px repeat-x;
  text-align: center;
  padding-top: 10px;
}
.stepper-stage-icon {
  display: inline-block;
  height: 60px;
  width: 60px;
  padding: 10px;
  color: #fff;
  border-radius: 30px;
  font-size: 20px;
  font-weight: bold;
  border: 5px solid #fff;
}
.stepper-stage-text {
  font-weight: bold;
  line-height: 2rem;
  color: #777;
}
.stepper-stage.active .stepper-stage-text {
  color: #212529;
}
.bg-gris {
  background-color: #bbb;
}
.clickable {
  cursor: pointer;
}
.clickable:hover {
  background-color: #eee;
}
.stepper-stage.clickable:hover {
  background-color: transparent;
}
.img-lista {
  width: 193px;
  height: 90px;
}
.nav-tabs > .nav-item {
    margin: 0!important;
  }
.nav-tabs > .nav-item > a {
  margin-left: 2px;
  margin-right: 2px;
}

@media screen and (max-width: 992px) {
  /*
  .img-lista {
    width: 144px;
    height: 65px;
  }
  */
  tr { 
    display: flex; 
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0.5em 0;
    border: 0!important;
    border-bottom: 1px solid rgba(3,3,3,0.2)!important;;
  }
  td, th {
    flex: 1 1 50%;
    border: 0!important;
    font-size: 0.8em;
  }
  
  
}
@media screen and (max-width: 768px) {
  .img-lista {
    width: 114px;
    height: 50px;
  }
  .label-lista {
    min-width: 100px;
    display: inline-block;
    text-align: right;
  }
  .label-ficha {
    padding-bottom: 0!important;
    margin-bottom: 0!important;
    margin-top: 5px!important;
  }
  h2.seccion {
    font-size: 1.4rem;
    padding-bottom: 5px;
  }
  h5 {
    font-size: 1.1rem;
  }
}
.navbar-toggler {
  padding: 0!important;
  margin-right: 400px!important;
}
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,<svg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'><path stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/></svg>")!important;
}
@media screen and (max-width: 768px) {
  .navbar-toggler {
    margin-right: 265px!important;
  }
}
@media screen and (max-width: 415px) {
  .navbar-toggler {
    margin-right: 90px!important;
  }
}
@media screen and (max-width: 375px) {
  .navbar-toggler {
    margin-right: 70px!important;
  }
}
@media screen and (max-width: 360px) {
  .navbar-toggler {
    margin-right: 65px!important;
  }
}
@media screen and (max-width: 320px) {
  .navbar-toggler {
    margin-right: 35px!important;
  }
}
</style>
